import { Checkbox, Select } from "antd";
import React, { useState } from "react";

import arrowDown from "../../../assets/icons/arrow-down12.png";

export default function AudienceOralHealthFilter({ setOralHealthFilter, oralHealthFilter }) {
  const [isArrowDown, setIsArrowDown] = useState(true);

  // Oral Health Filter
  const healthScoreRange = [
    { value: 1, label: "0 < score < 25" },
    { value: 2, label: "25 < score < 50" },
    { value: 3, label: "50 < score < 75" },
    { value: 4, label: "75 < score < 100" },
  ];

  const oralHealthOptions = [
    { value: "type 1", label: "type 1" },
    { value: "type 2", label: "type 2" },
    { value: "type 3", label: "type 3" },
    { value: "type 4", label: "type 4" },
  ];

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <p style={{ marginBottom: 20, fontSize: 18 }}>Oral Health Type</p>

        <Select
          options={oralHealthOptions}
          placeholder="Select Oral Health Type"
          value={oralHealthFilter.char_value || undefined}
          onChange={(value) => setOralHealthFilter((prevState) => ({ ...prevState, char_value: value }))}
          className="custom-style-selection"
          suffixIcon={<img src={arrowDown} alt="arrow-down" style={{ transform: `rotate(${isArrowDown ? "0" : "180deg"})` }} />}
          onOpenChange={() => setIsArrowDown((down) => !down)}
          style={{ width: "50%", display: "flex", alignItems: "center" }}
        />
      </div>

      <div>
        <p style={{ marginBottom: 5, fontSize: 18 }}>Oral Health Score</p>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {healthScoreRange.map((option) => (
            <Checkbox
              key={option.value}
              value={option.value}
              checked={option.value === oralHealthFilter.integer_value}
              onChange={(e) => setOralHealthFilter((prevState) => ({ ...prevState, integer_value: e.target.value }))}
              style={{ color: option.value === oralHealthFilter.integer_value ? "#6B43B5" : "#848696" }}
            >
              {option.label}
            </Checkbox>
          ))}
        </div>
      </div>
    </div>
  );
}
